'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { styled } from 'styled-components';
import { useId } from '../../util';
const radius = 2;
const strokeWidth = 0.25;
const useMask = () => {
  const maskId = useId('pageLoaderMask');
  const innerRadius = 50 * (1 - strokeWidth / radius);
  const svg = `<svg xmlns="http://www.w3.org/2000/svg">
  <mask id="${maskId}">
    <circle cx="50%" cy="50%" r="50%" fill="white" />
    <circle cx="50%" cy="50%" r="${innerRadius}%" fill="black"/>
  </mask>
  <circle cx="50%" cy="50%" r="50%" fill="black" mask="url(#${maskId})"/>
</svg>`;
  return `url('data:image/svg+xml;charset=utf8,${encodeURIComponent(svg.replace(/[\n\t ]+/g, ' '))}')`;
};
const Container = styled.div.withConfig({
  componentId: "aui__sc-5qywt8-0"
})(["display:flex;flex-direction:column;align-items:center;gap:1rem;color:var(--aui-on-surface);"]);
const Animation = styled.div.withConfig({
  componentId: "aui__sc-5qywt8-1"
})(["width:", "rem;height:", "rem;mask:intersect conic-gradient(from 180deg,rgba(0,0,0,0),rgba(0,0,0,1)),", ";background:var(--aui-on-surface);animation:aui-page-loader-spin 1s linear infinite;@keyframes aui-page-loader-spin{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}"], 2 * radius, 2 * radius, ({
  $maskUrl
}) => $maskUrl);
export const PageLoader = ({
  children,
  ...props
}) => {
  const maskUrl = useMask();
  if (typeof children === 'string') {
    children = /*#__PURE__*/React.createElement("span", null, children, /*#__PURE__*/React.createElement(Dot, {
      $index: 0
    }, "."), /*#__PURE__*/React.createElement(Dot, {
      $index: 1
    }, "."), /*#__PURE__*/React.createElement(Dot, {
      $index: 2
    }, "."));
  }
  return /*#__PURE__*/React.createElement(Container, _extends({}, props, {
    "data-aui": "loader.page"
  }), /*#__PURE__*/React.createElement(Animation, {
    $maskUrl: maskUrl
  }), children);
};
const Dot = styled.span.withConfig({
  componentId: "aui__sc-5qywt8-2"
})(["animation:", " 1s infinite;@keyframes ", "{0%{visibility:hidden;}25%{visibility:hidden;}50%{visibility:", ";}75%{visibility:", ";}100%{visibility:visible;}}"], ({
  $index
}) => `ellipses_${$index}`, ({
  $index
}) => `ellipses_${$index}`, ({
  $index
}) => $index <= 0 ? 'visible' : 'hidden', ({
  $index
}) => $index <= 1 ? 'visible' : 'hidden');